import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
@Component({
  selector: 'app-product-descriptions',
  imports: [MatExpansionModule, RouterModule],
  templateUrl: './product-descriptions.html',
  styleUrl: './product-descriptions.scss',
})
export class ProductDescriptions {
  @Input({ required: true }) descriptions: string[] = [];
}
